import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Payloc } from '../model/Payloc.model';
import { Router, ActivatedRoute } from '@angular/router';
import { PaylocService } from '../services/payloc.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SelectCustomerModalComponent } from '../select-customer-modal/select-customer-modal.component';
import { DropdownService } from '../../dropdowns/dropdown.service';
import { Observable, of } from 'rxjs';
import { tap, finalize, delay, map } from 'rxjs/operators';
import { Response } from '../../service/response.model';
import { SpinnerService } from '../../service/spinner.service';
import { defaultSearchDelay, COUNTRIES_WITH_STATES, STATEMENT_METHODS_WITH_EMAIL, COUNTRIES_WITH_REQUIRED_INFO } from '../../constants';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { AppNavigationService } from '../../service/app-navigation.service';
import { Option } from '../../dropdowns/models/option.model';
import { InputType } from '../../shared/field/input/input-type.enum';
import { statementMethodCrossValidator } from '../../shared/validation/statement-method-cross.validator';
import { CountryStateCrossRequired } from '../../shared/validation/country-state-cross-required.validator';
import { DecimalValidator } from '../../shared/validation/decimal-validator.function';
import { PayThreshAmtCrossValidator } from '../../shared/validation/pay-thresh-amt-cross-validator.function';
import { UtilService } from '../../service/util.service';
import { paymentMethodCrossValidator } from '../../shared/validation/payment-method-cross.validator';
import { PaymentMethod } from '../../shared/enums/paymentMethod.enum';
import { TranslateService } from '@ngx-translate/core';
import { Location } from "@angular/common";
import { CountryZipStatementRequired } from '../../shared/validation/country-zip-statement-required.validator';
import { Customer } from '../../customer/model/customer.model';


@Component({
  selector: 'subpayment-form',
  templateUrl: './subpayment-form.component.html',
  styleUrls: ['./subpayment-form.component.css']
})
export class SubpaymentFormComponent implements OnInit {

  formSubpayment: FormGroup;
  paylocResponse$: Observable<any>;
  payloc: Payloc;
  readonly: boolean;
  selectedId: number;
  isPaylocDisable: boolean = false;

  isGenInfoCardCollapsabled = false;
  isGenInfoStatementCardCollapsabled = false;
  isBankInfoCardCollapsabled = false;
  isBankInfoPrimaryCardCollapsabled = false;
  isBankInfoIntermediaryCardCollapsabled = false;
  isAuditCardCollapsabled = false;

  countryList$: Observable<Option[]>;
  stateList$: Observable<Option[]>[] = [];
  specialFlagList$: Observable<Option[]>;
  memberLevelList$: Observable<Option[]>;
  stateMethodList$: Observable<Option[]>;
  payMethodList$: Observable<Option[]>;
  payCurrList$: Observable<Option[]>;
  payCurrListInmutable$: Observable<Option[]>;
  payCurr2List$: Observable<Option[]>;

  isStateRequired: boolean[] = [];
  isThreshAmtRequired: boolean;
  isPayCurr2Required: boolean;
  canDelete: boolean = false;
  isMEmailRequired: boolean;

  isBankNameRequired: boolean;
  isBankAcctRequired: boolean;
  isBankAddr1Required: boolean;
  isCityRequired: boolean;
  isCountryRequired: boolean;
  isMZipRequired: boolean;

  inputType = InputType;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private paylocService: PaylocService,
    private modalService: NgbModal,
    private dropdownService: DropdownService,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    private flashMessagesService: FlashMessagesService,
    private appNav: AppNavigationService,
    private utilService: UtilService,
    private translate: TranslateService,
    private _location: Location) {
  }

  ngOnInit() {
    this.initform();
    this.initDropdowns();
    this.retrievePayloc();
  }

  initform() {
    this.formSubpayment = this.formBuilder.group({
      paymentNum: ['', null],
      statusFlag: ['', null],
      payName: ['', [Validators.required, Validators.maxLength(50)]],
      attentionName: ['', Validators.maxLength(50)],
      addr1: ['', [Validators.required, Validators.maxLength(50)]],
      addr2: ['', Validators.maxLength(50)],
      city: ['', [Validators.required, Validators.maxLength(50)]],
      state: [null, null],
      zip: ['', [Validators.required, Validators.maxLength(15)]],
      country: [null, Validators.required],
      phone: ['', Validators.maxLength(20)],
      fax: ['', Validators.maxLength(20)],
      email: ['', [Validators.required, Validators.maxLength(45), Validators.email]],
      taxId: ['', Validators.maxLength(30)],
      contact: ['', Validators.maxLength(30)],
      dataInfo: ['', Validators.maxLength(26)],
      specialFlag: [null, null],
      backOffice: ['', Validators.maxLength(30)],
      memberLevel: [null, Validators.required],
      acctMgr: ['', Validators.maxLength(30)],
      mcontact: ['', Validators.maxLength(45)],
      maddr1: ['', Validators.maxLength(50)],
      maddr2: ['', Validators.maxLength(50)],
      mcity: ['', Validators.maxLength(50)],
      mstate: [null, null],
      mzip: ['', Validators.maxLength(15)],
      mcountry: [null, null],
      mphone: ['', Validators.maxLength(20)],
      mfax: ['', Validators.maxLength(20)],
      memail: ['', [Validators.maxLength(45), Validators.email]],
      stateMethod: [null, Validators.required],
      payMethod: [null, Validators.required],
      payCurr: [null, Validators.required],
      payCurr2: [null, null],
      payFlag: [null, Validators.required],
      payThreshAmt: ['', [Validators.maxLength(10), DecimalValidator(6, 2)]],
      nationalId: ['', Validators.maxLength(15)],
      bankName: ['', Validators.maxLength(25)],
      beneName: ['', Validators.maxLength(50)],
      bankAcct: ['', Validators.maxLength(34)],
      bankRoute: ['', Validators.maxLength(16)],
      bankSwift: ['', Validators.maxLength(15)],
      bankId: ['', Validators.maxLength(10)],
      bankAddr1: ['', Validators.maxLength(50)],
      bankAddr2: ['', Validators.maxLength(50)],
      bankCity: ['', Validators.maxLength(50)],
      bankState: [null, null],
      bankZip: ['', Validators.maxLength(15)],
      bankCountry: [null, null],
      bankPhone: ['', Validators.maxLength(20)],
      intBankName: ['', Validators.maxLength(25)],
      intBankAcct: ['', Validators.maxLength(34)],
      intBankRoute: ['', Validators.maxLength(16)],
      intBankSwift: ['', Validators.maxLength(15)],
      intBankId: ['', Validators.maxLength(10)],
      intBankAddr1: ['', Validators.maxLength(50)],
      intBankAddr2: ['', Validators.maxLength(50)],
      intBankCity: ['', Validators.maxLength(50)],
      intBankState: [null, null],
      intBankZip: ['', Validators.maxLength(15)],
      intBankCountry: [null, null],
      intBankPhone: ['', Validators.maxLength(20)],
      customerNum: ['', [ Validators.required, Validators.maxLength(10)]]
    }, {
        validator: [
          CountryStateCrossRequired("country", "state", "stateRequiredCrossValidation"),
          CountryStateCrossRequired("mcountry", "mstate", "mstateRequiredCrossValidation"),
          CountryStateCrossRequired("bankCountry", "bankState", "bankStateRequiredCrossValidation"),
          CountryStateCrossRequired("intBankCountry", "intBankState", "intBankStateRequiredCrossValidation"),
          statementMethodCrossValidator,
          PayThreshAmtCrossValidator(),
          paymentMethodCrossValidator("bankName", "bankNameRequiredCrossValidation"),
          paymentMethodCrossValidator("bankAcct", "bankAcctRequiredCrossValidation"),
          paymentMethodCrossValidator("bankAddr1", "bankAddr1RequiredCrossValidation"),
          paymentMethodCrossValidator("bankCity", "bankCityRequiredCrossValidation"),
          paymentMethodCrossValidator("bankCountry", "bankCountryRequiredCrossValidation"),
          CountryZipStatementRequired("mcountry", "mzip", "mzipRequiredCrossValidation",),
        ], updateOn: 'blur'
    });
  }

  retrievePayloc() {
    let segments: string[] = this.router.url.split("/");
    this.selectedId = this.activatedRoute.snapshot.params.id;
    if (segments && segments.length > 0) {
      if (segments[segments.length - 1] === "edit") {
        this.readonly = true;
        this.spinnerService.startSpinner();
        this.paylocResponse$ = this.paylocService.getSingle(this.selectedId).pipe(
          tap((response: Response<Payloc>) => {
            this.payloc = response.output;
            if (this.payloc.statusFlag === "A"){
              this.canDelete = true;
            }
            this.payloc.payThreshAmt = this.utilService.parseToDecimal(this.payloc.payThreshAmt);
            this.payloc.customerNum = this.payloc.customer ? this.payloc.customer.customerNumber : null;
            this.formSubpayment.patchValue(response.output);
            this.setPayCurr2Required(this.payloc.payMethod);
            this.setPayThreshAmt(this.payloc.payFlag);
            this.setMEmailRequired(this.payloc.stateMethod);
            this.setInfoBankRequired(this.payloc.payMethod);
            this.initDependentDropdowns();
            this.spinnerService.stopSpinner();
          })
        );
      } else {
        this.readonly = false;
        this.payloc = new Payloc();
        this.setPayCurr2Required(this.payloc.payMethod);
        this.setPayThreshAmt(this.payloc.payFlag);
        this.setMEmailRequired(this.payloc.stateMethod);
        this.setInfoBankRequired(this.payloc.payMethod);
        this.paylocResponse$ = of(this.payloc);
        this.initDependentDropdowns();
      }
    }
  }

  initDropdowns() {
    this.countryList$ = this.dropdownService.getAllCodes('country');
    this.specialFlagList$ = this.dropdownService.getAllCodes('specialflag');
    this.memberLevelList$ = this.dropdownService.getAllMemberLevels();
    this.stateMethodList$ = this.dropdownService.getAllCodes('statementmethod');
    this.payMethodList$ = this.dropdownService.getAllCodes('paymentmethod');
    this.payCurrList$ = this.dropdownService.getAllCurrencies('payment');
    this.payCurrListInmutable$ = this.payCurrList$;
    this.payCurr2List$ = this.dropdownService.getAllCurrencies('secondary');
  }

  initDependentDropdowns() {
    // init States dropdowns
    this.stateList$['country'] = this.populateStateList(this.payloc.country);
    this.stateList$['mcountry'] = this.populateStateList(this.payloc.country);
    this.stateList$['bankCountry'] = this.populateStateList(this.payloc.country);
    this.stateList$['intBankCountry'] = this.populateStateList(this.payloc.country);

    // set States dropdown not required
    this.setStateRequired("country");
    this.setStateRequired("mcountry");
    this.setStateRequired("bankCountry");
    this.setStateRequired("intBankCountry");
  }

  populateStateList(countryCode: string): Observable<Option[]> {
    let stateList: Observable<Option[]>;
    if (countryCode) {
      stateList = this.dropdownService.getStatesByCountryCode(countryCode).pipe(
        tap(options => options.forEach(option => {
          if (option.value) {
            option.value = option.value.trim();
          }
        }))
      );
    } else {
      stateList = stateList = of([]);
    }
    return stateList;
  }

  onCountryChanged(countryControlName: string, stateControlName: string) {
    const countryValue = this.formSubpayment.controls[countryControlName].value;
    this.formSubpayment.controls[stateControlName].setValue(null);
    let observable$: Observable<Option[]>;
    if (countryValue) {
      observable$ = this.dropdownService.getStatesByCountryCode(countryValue);
    } else {
      observable$ = of([]);
    }
    this.stateList$[countryControlName] = observable$;
    this.setStateRequired(countryControlName);

    if (countryControlName = 'mcountry'){
      this.setMZipRequired();
    }
  }

  setStateRequired(countryControlName?: string) {
    this.isStateRequired[countryControlName] = COUNTRIES_WITH_STATES.includes(this.formSubpayment.controls[countryControlName].value);
  }

  setMZipRequired(){
    if (COUNTRIES_WITH_REQUIRED_INFO.includes(this.formSubpayment.controls['mcountry'].value)) {
      this.isMZipRequired = true;
    } else {
      this.isMZipRequired = false;
    }
  }

  eraseCustomerNum() {
    document.getElementById("customerNum").focus();
    this.formSubpayment.controls.customerNum.setValue("");
    this.formSubpayment.controls.customerNum.markAsDirty();
    this.formSubpayment.controls.customerNum.updateValueAndValidity();
    document.getElementById("attentionName").focus();
  }

  openSelectCustomerModal() {
    let options: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: 'lg'
    };
    const modalRef = this.modalService.open(SelectCustomerModalComponent, options);
    (<SelectCustomerModalComponent>modalRef.componentInstance).currentCustomerNumber = this.formSubpayment.controls.customerNum.value;
    modalRef.result.then((customerNum) => {
      document.getElementById("customerNum").focus();
      this.formSubpayment.controls.customerNum.setValue(customerNum);
      this.formSubpayment.controls.customerNum.markAsDirty();
      this.formSubpayment.controls.customerNum.updateValueAndValidity();
      document.getElementById("attentionName").focus();
    }).catch((error) => {
      console.log(error);
    });
  }

  onPayFlagChanged(payFlag: string) {
    this.formSubpayment.controls["payThreshAmt"].setValue(null);
    this.setPayThreshAmt(payFlag);
  }

  setPayThreshAmt(payFlag) {
    this.isThreshAmtRequired = (payFlag === 'Y');
  }

  onPayMethodChange(newValue) {
    this.formSubpayment.controls.payCurr2.setValue(null);
    if (!newValue) {
      this.formSubpayment.controls.payCurr.setValue(null);
    }

    if((newValue === PaymentMethod.WIRE_TRANSFER) && (this.payloc.payMethod !== PaymentMethod.WIRE_TRANSFER)){
      this.translate.get('fieldValidation.wireValidation').subscribe(msg =>
        {
          this.flashMessagesService.info(msg);
        });
    }

    this.filterPaymentCurrency(newValue);
    this.setPayCurr2Required(newValue);
    this.setInfoBankRequired(newValue);
  }

  setPayCurr2Required(payMethod) {
    this.isPayCurr2Required = (payMethod === PaymentMethod.WIRE_TRANSFER);
  }

  onStatementMethodChanged(newValue){
    this.setMEmailRequired(newValue);
  }

  setMEmailRequired(stateMethod) {
    if (STATEMENT_METHODS_WITH_EMAIL.includes(stateMethod)) {
      this.isMEmailRequired = true;
    } else {
      this.isMEmailRequired = false;
    }
  }

  setInfoBankRequired(payMethod){
    if(payMethod === PaymentMethod.DIRECT_DEPOSIT){
      this.isBankNameRequired = true;
      this.isBankAcctRequired = true;
      this.isBankAddr1Required = true;
      this.isCityRequired = true;
      this.isCountryRequired = true;
    }else{
      this.isBankNameRequired = false;
      this.isBankAcctRequired = false;
      this.isBankAddr1Required = false;
      this.isCityRequired = false;
      this.isCountryRequired = false;
    }
  }

  filterPaymentCurrency(payMethod) {
    this.payCurrList$ = this.payCurrListInmutable$.pipe(
      map(options =>
        options.filter(option => option.payMethod === payMethod)
      ),
      tap(options => {
        let payCurrSelected = this.formSubpayment.controls.payCurr.value;
        if (payCurrSelected && !options.find(option => (option.payMethod === payMethod && option.value === payCurrSelected))) {
          this.formSubpayment.controls.payCurr.setValue(null);
        }
      })
    );
  }

  cancel(e: Event) {
    e.preventDefault();
    this._location.back();
  }

  editableForm() {
    this.readonly = false;
  }

  isValidForm() {
    return this.formSubpayment.valid;
  }

  changeStatus(){
    if(this.payloc.statusFlag === 'A'){
      this.canDelete = true;
    }else{
      this.canDelete = false;
    }
  }

  onSubmit() {
    this.payloc = Object.assign(this.formSubpayment.value);
    this.payloc.payThreshAmt = this.utilService.parseToInteger(this.payloc.payThreshAmt);

    if (this.payloc.customerNum) {
      this.payloc.customer = new Customer();
      this.payloc.customer.customerNumber = this.payloc.customerNum;
    }

    if (this.selectedId === undefined) { // Create
      this.spinnerService.startSpinner();
        this.payloc.paymentNum = null;
        this.paylocService.add(this.payloc).pipe(
          delay(defaultSearchDelay),
          finalize(() => this.spinnerService.stopSpinner())
        ).subscribe((data) => {
          this.payloc = data['output'];
          if (data['successful']) {
            if(this.payloc.validations && !this.payloc.validations.isValid){
              // Data is not valid
              return this.validationErrors();
            }else {
              this.flashMessagesService.success('Payment Location successfully created. Payloc ID: ' + this.payloc.paymentNum);
              this.readonly = true;
              return this.appNav.goToPayLoc(this.payloc.paymentNum);
            }
          }
        },
          error => {
            this.paylocService.handleError('updatePayloc', error);
          });
    } else {
      if(this.readonly && this.canDelete){ // Disable
        this.spinnerService.startSpinner();
        this.paylocResponse$ = this.paylocService.delete(this.selectedId).pipe(
          tap((response: Response<Payloc>) => {
            if(response['successful']){
              this.payloc = response["output"];
              this.formSubpayment.patchValue(this.payloc);
              this.flashMessagesService.success('Payment Location successfully deleted. Payloc ID: ' + this.payloc.paymentNum);
              this.canDelete= false;
              this.appNav.goToPayLoc(this.payloc.paymentNum);
              this.spinnerService.stopSpinner();
            }
          }),
        );
      }else if (this.readonly && !this.canDelete){ //Reactive
        this.spinnerService.startSpinner();
          this.paylocResponse$ = this.paylocService.reactivate(this.selectedId, this.payloc).pipe(
            tap((response: Response<Payloc>) => {
              if(response['successful']){
                this.payloc = response["output"];
                this.formSubpayment.patchValue(this.payloc);
                this.flashMessagesService.success('Payment Location successfully reactivated. Payloc ID: ' + this.payloc.paymentNum);
                this.canDelete= true;
                this.appNav.goToPayLoc(this.payloc.paymentNum);
                this.spinnerService.stopSpinner();
              }
            }),

          );
      }else{ // Update
        this.spinnerService.startSpinner();
        this.paylocService.update(this.selectedId, this.payloc).pipe(
        delay(defaultSearchDelay),
        finalize(() => this.spinnerService.stopSpinner())
      ).subscribe((data) => {
        this.payloc = data['output'];
        if (data['successful']) {
          if(this.payloc.validations && !this.payloc.validations.isValid){
            // Data is not valid
            return this.validationErrors();
          }else{
            this.flashMessagesService.success('Payment Location successfully updated. Payloc ID: ' + this.payloc.paymentNum);
            this.readonly = true;
            return this.appNav.goToPayLoc(this.payloc.paymentNum);
          }
        }
      },
        error => {
          this.paylocService.handleError('updatePayloc', error);
        });
      }
    }
  }

  /**
   * Extract the validation errors
   *
   * @returns {boolean}
   */
  private validationErrors(){
    this.payloc.validations.fieldErrors.forEach(error => {
      this.flashMessagesService.error(error.errorMsg);
    });
    return false;
  }

  onKeyDownForCustomerNum(event: KeyboardEvent) {
    if (event.key !== 'Tab') {
      event.preventDefault();
    }
  }

  onFocusOutForCustomerNum() {
    this.formSubpayment.controls.customerNum.markAsDirty();
  }

}
